import React, { useEffect, useState } from "react";
import { SettingsFormLayout } from "./SettingsFormLayout";
import { FormControlLabel, Switch, Typography } from "@mui/material";
import useStore from "../../../states/store";
import { usePage } from "@inertiajs/react";
import { updateOrCreateUserPreference } from "../../../config/apisauce";
import useNotiStack from "../../../hooks/useNotiStack";

export const TakeProfileOffline = () => {
  const { success } = useNotiStack();
  const { auth } = usePage().props;
  const [{ userPreference, loaderState }, { openLoader, closeLoader, setUserPreference }] = useStore();
  const [allowCollaborations, setAllowCollaborations] = useState(false);

  const handleSavePreference = async () => {
    openLoader();
    const response = await updateOrCreateUserPreference({
      user_id: auth?.user?.id,
      preferences: {
        ...userPreference,
        allow_collaborators: allowCollaborations
      },
    });
    if (response.ok) {
      success('Successfully updated preferences!');
      setUserPreference({ ...userPreference, allow_collaborators: allowCollaborations })
    }
    closeLoader();
  };

  useEffect(() => {
    setAllowCollaborations(userPreference?.allow_collaborators);
  }, [userPreference]);

  return (
    <SettingsFormLayout
      title={'Take Profile Offline'}
      subTitle={'Control whether other users can send you collab requests.'}
      buttonText={'Save Preferences'}
      action={() => handleSavePreference()}
      disabled={loaderState}
    >
      <FormControlLabel control={<Switch checked={allowCollaborations} onChange={(event) => setAllowCollaborations(event.target.checked)} />} label="Allow Collab" />
      <Typography mt={0.5}>
        {
          allowCollaborations ? 'You are currently accepting collab requests. Other users can send you invites to collaborate.' :
            'Your profile is currently hidden from the site, but your pending collab requests remain active.'
        }
      </Typography>
    </SettingsFormLayout>
  )
};